import { Component, Input, OnChanges } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, BehaviorSubject} from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { switchMap, map } from 'rxjs/operators';

//TODO: DELETE AND REPLACE THIS COMPONENT: it is not recommended to use functions inside img src; makes application do numerous http request for same image if response is 404 which greatly slows loading time
//ALSO HAS POSSIBLE XSS ATTACK VECTOR @loadImage(url)

@Component({
  selector: 'secured-image',
  template: `
    <img id="{{id}}" [src]="dataUrl$|async" width="auto"  height="{{height}}" />
  `
})
export class SecuredImageComponent implements OnChanges  {
  // This part just creates an rxjs stream from the src
  // this makes sure that we can handle it when the src changes
  // or even when the component gets destroyed
  @Input() private src?: string;
  @Input() public height: string;
  @Input() public id: string;

  private src$ = new BehaviorSubject(this.src);

  // this stream will contain the actual url that our img tag will load
  // everytime the src changes, the previous call would be canceled and the
  // new resource would be loaded
  dataUrl$ = this.src$.pipe(switchMap(url => this.loadImage(url)))

  ngOnChanges(): void {
    this.src$.next(this.src);
  }

  // we need HttpClient to load the image and DomSanitizer to trust the url
  constructor(private httpClient: HttpClient, private domSanitizer: DomSanitizer) {
  }

  private loadImage(url: string): Observable<any> {
    // don't use security bypassing, exposes app to XSS attacks... https://angular.io/api/platform-browser/DomSanitizer
    return this.httpClient
      .get(url, {responseType: 'blob'})
      .pipe(map(e => this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(e))))
  }
}
